import { useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Plus, MagnifyingGlass } from "@phosphor-icons/react";
import { Switch } from "@/components/ui/switch";
import { Section } from "@/components/builder/IdentitySection";
import { SkillDialog } from "@/pages/Skills";
import { Icon } from "@/lib/icons";
import { api } from "@/lib/api";

export const SkillsSection = ({ form, set }) => {
  const qc = useQueryClient();
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(false);
  const { data } = useQuery({ queryKey: ["skills"], queryFn: async () => (await api.get("/skills")).data });
  const all = [...(data?.custom || []), ...(data?.predefined || [])].filter((s) => (s.name + s.description + s.category).toLowerCase().includes(q.toLowerCase()));
  const toggle = (id) => set("skill_ids", form.skill_ids.includes(id) ? form.skill_ids.filter((x) => x !== id) : [...form.skill_ids, id]);

  return (
    <Section id="skills" title={`Skills · ${form.skill_ids.length} activas`} desc="Activa habilidades predefinidas o crea las tuyas. Se combinan con las instrucciones.">
      <div className="flex gap-2">
        <div className="flex flex-1 items-center gap-2 border border-white/10 bg-[#0d0d0d] px-3"><MagnifyingGlass size={15} className="text-zinc-500" /><input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar skills…" className="h-10 flex-1 bg-transparent text-sm focus:outline-none" data-testid="builder-skills-search" /></div>
        <button onClick={() => setOpen(true)} className="btn-ghost !py-2" data-testid="builder-skill-create-button"><Plus size={15} /> Crear skill</button>
      </div>
      <div className="grid gap-px border border-white/10 bg-white/10 md:grid-cols-2">
        {all.map((s) => {
          const on = form.skill_ids.includes(s.skill_id);
          return (
            <div key={s.skill_id} onClick={() => toggle(s.skill_id)} className={`flex cursor-pointer items-start gap-3 p-4 ${on ? "bg-blue-600/10" : "bg-[#080808] hover:bg-[#101010]"}`} data-testid={`builder-skill-${s.skill_id}`} style={{ transition: "background-color 160ms" }}>
              <Icon name={s.icon} size={20} weight="duotone" className={`mt-0.5 shrink-0 ${s.predefined ? "text-blue-500" : "text-cyan-400"}`} />
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2"><p className="text-sm font-semibold">{s.name}</p>{!s.predefined && <span className="border border-cyan-500/30 px-1.5 text-[9px] uppercase tracking-wider text-cyan-400">Propia</span>}</div>
                <p className="mt-0.5 text-xs text-zinc-500">{s.description}</p>
              </div>
              <Switch checked={on} onCheckedChange={() => toggle(s.skill_id)} onClick={(e) => e.stopPropagation()} data-testid={`builder-skill-switch-${s.skill_id}`} />
            </div>
          );
        })}
      </div>
      <SkillDialog open={open} onOpenChange={setOpen} onSaved={(s) => { qc.invalidateQueries({ queryKey: ["skills"] }); set("skill_ids", [...form.skill_ids, s.skill_id]); }} />
    </Section>
  );
};
